import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ProvinceForm from '../../../components/forms/ProvinceForm';
import { useCreateProvince } from '../../../hooks/useProvinceApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ProvinceDTO } from '../../../services/apiClient';

const ProvinceCreate: React.FC = () => {
  const createProvince = useCreateProvince();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Provinces', href: '/admin/provinces' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ProvinceDTO) => {
    try {
      await createProvince.mutateAsync(data);
      navigate('/admin/provinces');
    } catch (error) {
      console.error('Error creating Province:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/provinces"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Province.Edit'
    >
        <ProvinceForm
          initialValues={{} as ProvinceDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/provinces')}
        />
    </AdminLayout>
  );
};

export default ProvinceCreate;